import axios from "axios"

const getWatchModelDetails = async (watchNo) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/get_specs/${watchNo}`)
    return response?.data || null
}

const getWatchModelStory = async (watchNo) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/generate_story/${watchNo}`)
    return response?.data || null
}

const watchService = { getWatchModelDetails, getWatchModelStory }
export default watchService